/* eslint-disable react/no-array-index-key */
import React from "react";
import clsx from "clsx";

// Material
import { makeStyles } from "@material-ui/core/styles";

// Assets
import headingArrow from "../../assets/icons/heading-arrow.svg";

// Config
import colors from "../../config/colors";

// Components
import Text, { types } from "../Text/Text";

const useStyles = makeStyles(theme => ({
  heading: {
    marginBottom: theme.spacing(3),
    // maxWidth: 650,
    textTransform: "uppercase",
    fontSize: "28px",
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
      maxWidth: 494
    }
  },
  headingArrow: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      height: 10,
      marginRight: theme.spacing(1)
    }
  },
  title: {
    whiteSpace: "pre-line",
    maxWidth: "31ch",
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("md")]: {
      maxWidth: 494,
      marginBottom: theme.spacing(2)
    }
  },
  description: {
    marginBottom: theme.spacing(3),
    maxWidth: 700,
    lineHeight: 1.4,
    "& span": {
      color: colors.lightBlue,
      fontWeight: "bold"
    },
    "& i": {
      color: colors.doveGray
    },
    [theme.breakpoints.down("md")]: {
      maxWidth: 494,
      marginBottom: theme.spacing(2)
    }
  },
  barContainer: {
    width: "100%",
    maxWidth: 650,
    borderRadius: "62px",
    marginBottom: theme.spacing(3),
    boxShadow: "0px 3px 16px #0000000F",
    [theme.breakpoints.down("md")]: {
      maxWidth: 494
    }
  },
  barContent: {
    borderRadius: "62px",
    height: "22px",
    width: ({ width }) => `${width}%`,
    background:
      "transparent linear-gradient(90deg, #3ACCE1 0%, #25e7bd 100%) 0% 0% no-repeat padding-box",

    [theme.breakpoints.down("md")]: {
      height: "14px"
    }
  }
}));

const HomeSubsection = ({
  heading,
  title,
  descriptions = [],
  children,
  width = 0
}) => {
  const classes = useStyles({ width });
  return (
    <div>
      <Text
        type={types.subsectionHeading}
        className={classes.heading}
        component="h3"
      >
        <img src={headingArrow} alt="" className={classes.headingArrow} />
        {heading}
      </Text>
      <div className={classes.barContainer}>
        <div className={classes.barContent} />
      </div>
      <Text type={types.subsectionTitle} className={clsx(classes.title)}>
        {title}
      </Text>
      {descriptions.map((content, i) => (
        <Text
          key={i}
          type={types.subsectionTitle}
          className={clsx(classes.title)}
        >
          {content}
        </Text>
      ))}
      {/* {descriptions.map((content, i) => (
        <Text
          key={i}
          type={types.subsectionDescription}
          className={classes.description}
        >
          {content}
        </Text>
      ))} */}
      {children}
    </div>
  );
};

export default HomeSubsection;
